module.exports = __webpack_public_path__ + "img/env-poll-b@2x.6c98996e.png";